<div class="hour-details mat-elevation-z2">

  <ng-container *ngIf="(isHotel ? (service.hotelInformation$ | async) : (service.imageInformation$ | async)) as data;else noHourDetails">
    <h2 [@opacityFade] translate="search-result.hours"></h2>
    <div class="hour-details--list" [@opacityFade]>
      <div class="hour-details--list-item" *ngFor="let item of hourDetails;">
        <div class="hour-details--list-item-sched">
          <p style="width: 100px;">{{ item.day | calendarDay }}</p>
          <p style="width: 100px;" class="ht-digit">{{ item.start | dayTime }}</p>
          <p style="width: 12px;" class="ht-digit" *ngIf="item.end">-</p>
          <p style="width: 100px;" class="ht-digit" *ngIf="item.end">{{ item.end | dayTime }}</p>
          <p></p>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-template #noHourDetails>
    <h2 translate="search-result.hours"></h2>
    <mat-progress-spinner class="primary" diameter="60" mode="indeterminate" style="margin-bottom: 24px;"></mat-progress-spinner>
  </ng-template>

</div>
